import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import lock_svg from '../../../pages/admin/admin_assets/img/Lock.svg';
import new_user from '../../../pages/admin/admin_assets/img/new_user.png';

const NewInviteForm = () => {
    const [newPassword, setNewPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const token = new URLSearchParams(window.location.search).get('token');

    useEffect(() => {
    
    if (!token) {
        setErrorMessage('No token found.');
        toast.error('No token found.');
        setTimeout(() => navigate('/'), 1500);
        return;
    }

    const fetchEmail = async () => {
        try {
            const response = await axios.get(
                'https://api.skepper.in/check-email-client-2.php',
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                console.log('Email fetched:', response.data.email);
                setEmail(response.data.email);
            } else {
                setErrorMessage(response.data.message || 'No email found.');
                toast.error(response.data.message || 'No email found.');
                setTimeout(() => navigate('/'), 1500);
            }
        } catch (error) {
            console.error('Error fetching email:', error);
            setErrorMessage('Failed to retrieve email.');
            toast.error('Failed to retrieve email.');
            setTimeout(() => navigate('/'), 1500);
        }
    };

    fetchEmail();
}, []);

    
    

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the password before submission
    const validation = validatePassword(newPassword);
    if (!validation.valid) {
        setErrorMessage(validation.message);
        toast.error(validation.message); // Show toast for better visibility
        return;
    }

    if (!token) {
        const errorMsg = 'No token found.';
        setErrorMessage(errorMsg);
        toast.error(errorMsg); // Added toast for consistency
        return;
    }

    try {
        const response = await axios.post(
            'https://api.skepper.in/set-password-client-2.php',
            { token, newPassword }
        );

        console.log('API Response:', response.data);  // Confirm what the API returns

        if (response.data.success) {
            toast.success('Password created successfully!');
            setTimeout(() => navigate('/client'), 2000);  // Slightly faster redirection
        } else {
            setErrorMessage(response.data.message);
            toast.error(response.data.message);
        }
    } catch (error) {
        const errorMsg = error.response?.data?.message || 'An unexpected error occurred.';
        console.error('Error:', errorMsg);
        setErrorMessage(errorMsg);
        toast.error(errorMsg);
    }
    };

// Dynamic password validation function
    const validatePassword = (password) => {
        console.log(`Validating password: ${password}`);  // Confirm the function is called

        if (password.length < 8) {
            return { valid: false, message: 'Password must be at least 8 characters long.' };
        }

        const uniqueChars = new Set(password).size;
        if (uniqueChars < 6) {
            return { valid: false, message: 'Password must include at least 6 different characters.' };
        }

        // Optional: Enforce stronger complexity rules
        if (!/[a-z]/.test(password) ||       // At least one lowercase
            !/[A-Z]/.test(password) ||       // At least one uppercase
            !/\d/.test(password) ||          // At least one number
            !/[^a-zA-Z\d]/.test(password))   // At least one special character
        {
            return { valid: false, message: 'Password must include an uppercase letter, lowercase letter, a number, and a special character.' };
        }

        return { valid: true };
    };
    

    return (
        <>
            <div className="login-form-content">
                <h1 className="login-heading black_txt">Set Your Password</h1>
                <p className="login-text black_txt">Please set your new password to continue.</p>
                <form onSubmit={handleSubmit}>
                    {/* Display dynamic email */}
                    <div className="form-group email-group new_user_pic">
                        <img src={new_user} className="email_icon" alt="Email Icon" />
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email || ''}  // Display dynamic email
                            disabled
                            required
                        />
                    </div>

                    <p className="new_user_para">
                        Make sure your new password is at least 8 characters and includes at least 6 different characters.
                    </p>

                    <div className="form-group password-group">
                        <img src={lock_svg} className="lock_icon" alt="Lock Icon" />
                        <label htmlFor="password">
                            Enter New Password <sup><i className="bi bi-asterisk"></i></sup>
                        </label>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                name="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                            />
                            <span className="toggle-password" onClick={togglePasswordVisibility}>
                                <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                            </span>
                        </div>
                    </div>

                    <button type="submit" className="login-button">Set Password</button>
                </form>

                {errorMessage && (
                    <div className="error_msg">
                        <p>{errorMessage}</p>
                    </div>
                )}
            </div>

            <ToastContainer />
        </>
    );
};

export default NewInviteForm;
